export enum FooterAction {
	SelectAll,
	SelectNone,
	Apply,
}
